import React from "react";
import { useNavigate } from "react-router-dom";
import "../Css/JeeHero.css";
import bg from "../assets/group.jpg";

import boys from "../assets/boys.png";
import study from "../assets/study.png";

import group from "../assets/group.jpg";
import jee from "../assets/jee.jpg";
import iitjee from "../assets/iitjee.jpg";

import skilled from "../assets/skilled.png";
import Supportive from "../assets/Supportive.png";
import Education from "../assets/Education.png";

const JeeHero = () => {
  const navigate = useNavigate();

  return (
    <>
   <section
  className="jee-hero"
  style={{ backgroundImage: `url(${bg})` }}
>
  <div className="jee-overlay"></div>

  <div className="jee-container">
    <div className="jee-card">
      <span className="jee-tag">Guided by IITians • Results Driven</span>

      <h1>IITian’s Home Tuition for JEE</h1>

      <p>
        Dreaming of cracking <strong>IIT-JEE (Mains & Advanced)</strong> and
        securing admission into India’s top engineering institutes like
        <strong> IITs, NITs, and IIITs</strong>?  
        <strong> IITian’s Chinmay Academy</strong> offers expert-led home tuition
        guided by experienced IITians who understand the exact exam pattern,
        mindset, and strategy required to succeed.
      </p>

      <p>
        Our IITian mentors provide <strong>personalized one-to-one guidance</strong>,
        structured study plans, advanced problem-solving techniques, regular
        mock tests, and in-depth concept clarity. We focus on building strong
        fundamentals, speed, accuracy, and confidence needed to excel in
        highly competitive JEE exams.
      </p>

      <button
        className="jee-btn"
        onClick={() => navigate("/contact")}
      >
        Enquire Now
      </button>
    </div>
  </div>
</section>

   <section className="why-choose-section">
  <div className="why-container">

    <h2 className="why-title">Why Choose IITian’s Chinmay Academy?</h2>

    <p className="why-subtitle">
      At IITian’s Chinmay Academy, learning is guided directly by IITians who have
      cracked the IIT-JEE themselves. Our goal is not just exam preparation, but
      building strong fundamentals, confidence, and an IIT-level problem-solving
      mindset in every student.
    </p>

    <div className="why-grid">

      {/* CARD 1 */}
      <div className="why-card">
        <img src={skilled} alt="IITian Faculty for JEE" />
        <h3>IITian Faculty with Proven JEE Expertise</h3>
        <p>
          Learn directly from experienced <strong>IITian mentors</strong> who
          understand the exact demands of <strong>IIT-JEE Mains and Advanced</strong>.
          Our faculty simplifies complex concepts in Physics, Chemistry, and
          Mathematics using real exam insights and proven strategies followed at IITs.
        </p>
      </div>

      {/* CARD 2 */}
      <div className="why-card">
        <img src={Supportive} alt="Personalised IITian Mentorship" />
        <h3>Personalised One-to-One IITian Mentorship</h3>
        <p>
          Every student receives <strong>personalised guidance from IITians</strong>
          based on learning pace, strengths, and weak areas. Regular doubt-solving,
          adaptive study plans, and continuous performance tracking ensure focused
          preparation and steady improvement for top JEE ranks.
        </p>
      </div>

      {/* CARD 3 */}
      <div className="why-card">
        <img src={Education} alt="Holistic JEE Preparation by IITians" />
        <h3>Holistic JEE Preparation & Academic Care</h3>
        <p>
          Our IITian-led approach goes beyond textbooks. Along with rigorous JEE
          preparation, we develop essential skills like analytical thinking,
          time management, exam temperament, and mental resilience—qualities required
          to succeed at IITs and in future engineering careers.
        </p>
      </div>

    </div>
  </div>
</section>



    <section className="jee-expertise-section">
      <div className="jee-expertise-container">

        {/* ===== TOP AREA ===== */}
        <div className="jee-top-area">

          {/* Left Illustration */}
          <div className="jee-top-left">
            <img src={boys} alt="JEE Coaching Student" />
          </div>

          {/* Right Content */}
          <div className="jee-top-right">
            <h2>Our Expertise</h2>
            <h3>JEE Coaching</h3>

            <div className="jee-info-box">
              <p>
                The <strong>Joint Entrance Examination (JEE)</strong> is among the
                most competitive engineering entrance exams in India. It acts as
                the primary gateway for admission into prestigious institutions
                such as <strong>IITs, NITs, IIITs</strong>, and other
                government-funded technical colleges.
              </p>

              <p>
                <strong>IITian’s Chinmay Academy</strong> provides expert-led JEE
                coaching with a strong focus on concept clarity, analytical
                thinking, and problem-solving skills required to succeed in
                highly competitive exams.
              </p>
            </div>
          </div>
        </div>

        {/* ===== BOTTOM AREA ===== */}
        <div className="jee-bottom-area">

          <h3 className="jee-bottom-title">
            The JEE Primarily Consists of Two Parts
          </h3>

          <div className="jee-bottom-grid">

            {/* JEE Main */}
            <div className="jee-card">
              <h4>JEE Main</h4>
              <p>
                JEE Main is conducted by the National Testing Agency (NTA) and
                serves as the qualifying examination for JEE Advanced. It is
                conducted multiple times a year and tests students on
                <strong> Physics, Chemistry, and Mathematics</strong>.
              </p>

              <p>
                Performance in JEE Main determines eligibility for top
                engineering institutes and is the foundation for advanced-level
                preparation.
              </p>
            </div>

            {/* JEE Advanced */}
            <div className="jee-card">
              <h4>JEE Advanced</h4>
              <p>
                JEE Advanced is conducted by one of the IITs and is known for its
                high difficulty level. It evaluates students’ conceptual depth,
                logical reasoning, and advanced problem-solving abilities.
              </p>

              <p>
                Only top-performing JEE Main candidates qualify for this exam,
                which ultimately leads to admission into the IITs.
              </p>
            </div>

            {/* Right Illustration */}
            <div className="jee-book-image">
              <img src={study} alt="JEE Study Material" />
            </div>

          </div>
        </div>

      </div>
    </section>

    <section className="jee-guide-section">
  <div className="jee-guide-container">

    {/* LEFT CONTENT */}
    <div className="jee-guide-content">
      <h2>
        A Complete Guide to Demystifying the Joint Entrance Examination
      </h2>

      <p>
        The <strong>Joint Entrance Examination (JEE)</strong>, which opens doors
        to the most esteemed technical colleges in India, is the apex of
        entrance tests for aspiring engineers. This guide aims to explain
        everything about JEE, whether you are a student preparing for the exam
        or a parent navigating this challenging admission process.
      </p>
    </div>

    {/* RIGHT IMAGE */}
    <div className="jee-guide-image">
      <img src={group} alt="JEE Students" />
    </div>

  </div>
</section>


    <section className="jee-ecosystem-section">
  <h2 className="jee-ecosystem-title">
    Knowledge of the JEE Ecosystem
  </h2>

  {/* ===== CARD 1 ===== */}
  <div className="jee-ecosystem-card">
    <h3>JEE Advanced vs. Main</h3>

    <div className="jee-ecosystem-content">
      <div className="jee-ecosystem-image">
        <img src={jee} alt="JEE Main vs Advanced" />
      </div>

      <ul className="jee-ecosystem-points">
        <li>
          <strong>JEE Main:</strong> Conducted by the National Testing Agency (NTA),
          JEE Main acts as the initial qualifying exam and determines eligibility
          for JEE Advanced.
        </li>
        <li>
          <strong>JEE Advanced:</strong> Entry to prestigious IITs is possible
          only through JEE Advanced. Only top JEE Main performers reach this level.
        </li>
      </ul>
    </div>
  </div>

  {/* ===== CARD 2 ===== */}
  <div className="jee-ecosystem-card">
    <h3>Subjects and Curriculum</h3>

    <div className="jee-ecosystem-content">
      <div className="jee-ecosystem-image">
        <img src={iitjee} alt="JEE Subjects" />
      </div>

      <ul className="jee-ecosystem-points">
        <li>
          The core subjects include <strong>Mathematics, Physics, and Chemistry</strong>.
          Mastery of these subjects is essential for success.
        </li>
        <li>
          The JEE syllabus closely follows the senior secondary curriculum but
          requires deeper conceptual understanding and application.
        </li>
      </ul>
    </div>
  </div>
</section>

    <section className="how-it-works">
  <div className="how-container">

    <h2 className="how-title">How It Works</h2>

    <div className="how-content">
      <p>
        Booking <strong>IITian's Academy</strong> with <strong>IITian's Chinmay Academy</strong> is simple
        and hassle-free. In just three easy steps, your child gets access to
        expert IITian mentors and personalised learning at home.
      </p>

      <ul className="how-steps">
        <li>
          <strong>Step 1:</strong> Fill out the online registration form with your
          child’s academic requirements.
        </li>
        <li>
          <strong>Step 2:</strong> We match you with an experienced IITian tutor
          best suited for JEE preparation.
        </li>
        <li>
          <strong>Step 3:</strong> Schedule sessions and begin focused,
          one-to-one learning at home.
        </li>
      </ul>
    </div>

    {/* CALL TO ACTION */}
    <div className="how-call-box">
      <h3>Give Us a Call</h3>
      <p>
        Speak directly with our academic experts to discuss your child’s JEE
        preparation needs.
      </p>

      <a href="tel:+918849189845" className="how-call-btn">
        📞 +91 8849189845
      </a>
    </div>

  </div>
</section>


</>
  );
};

export default JeeHero;
